module.exports = __webpack_public_path__ + "static/media/stadium_1.1ed8b9a0.jpg";